	import React, { useCallback, useEffect, useState } from 'react';

import { EVENT_REACH_PHONE_FORM } from '../../constants';
import { emitEvent } from '../../event-emitter';

import { PhoneForm } from '../phone-form/phone-form';
import { ecommerce, EcommerceAction } from '../../ecommerce.module';
import { Service } from '../../models/service.model';
import { getServiceName } from '../../utils/library';
import { PhoneFormData } from '../../interfaces/phone-form-data.interface';
import { useCreateLead } from '../../hooks/use-create-lead.hook';
import { FormType } from '../../enums/form-type.enum';
import { isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { displayPopupWindow, setActivePopupWindowId } from '../../reducers/quiz/quiz.actions';
import { PopupWindowID } from '../../enums/popup-window-id.enum';
import { WhatsappFormDefault } from '../whatsApp-form/whatsapp-form-default';

import styles from './fast-form.module.scss';
import { State } from '../../reducers/history/interfaces/state.interface';
import { StateType } from '../../reducers/history/enums/state-type.enum';

interface FastFormProps {
  currentService: Service | "selection";
  phoneFormState: PhoneFormData;
  whatsApp?: {
    enable: boolean
    phone: string;
    start_page_text?: string;
  },
  moveTo: (state:State) => void
}

export function FastForm(props:FastFormProps) {
	const { currentService, phoneFormState, whatsApp, moveTo } = props;
  const createLead = useCreateLead(FormType.FAST_FORM);
  const lead_id = useSelector((state:RootState) => state.client?.lead?._id);
  const dispatch = useDispatch();
  const [ leadSent, setLeadSent ] = useState(false);

  useEffect(() => {
    moveTo({ type: StateType.NULL })
  }, [moveTo]);
  
  
	useEffect(() => emitEvent(EVENT_REACH_PHONE_FORM, {form: 'fast-form'}), []);

  useEffect(() => {
    ecommerce.add(EcommerceAction.REVIEW, {
      id: 'fast_form',
      name: 'Быстрая форма',
      category: getServiceName(currentService)
    });
  }, [currentService]);

  const submitForm = async ({phone, name, additionalAgreement }:PhoneFormData) => {
    const lead = await createLead({phone, name, additionalAgreement });
    ecommerce.add(EcommerceAction.CART, {
      id: 'fast_form',
      name: 'Быстрая форма',
      category: getServiceName(currentService)
    });
    setLeadSent(true);
    if (lead._id) ecommerce.purchase(lead._id);
	}

  const submitWhatsappForm = useCallback(async () => {
    if (!lead_id) {
      setTimeout(() => {
        dispatch(setActivePopupWindowId(PopupWindowID.WHATSAPP_INSTRUCTIONS));
        dispatch(displayPopupWindow(true));
      }, 1000);
    } else {
      setTimeout(() => {
        dispatch(displayPopupWindow(false));
      }, 1000);
    }
    setLeadSent(true);
  }, [lead_id]);

	return (
		<section className={styles.fastForm}>
      {leadSent ? <h2 className={styles.header}> Готово! Мы с вами свяжемся!</h2> :
				<h2 className={styles.header}>
					<i>Узнайте цену на </i>
					<i>стоматологические услуги!</i>
				</h2>}
			{!leadSent && <> 
        {(isMobile && whatsApp?.enable) ? 
          <WhatsappFormDefault 
            whatsappParams={{ phone: whatsApp.phone, text: whatsApp.start_page_text || "Узнать цены", form_type: FormType.FAST_FORM }}
            buttonMode="whatsAppInitial"
            buttonText='Узнать по whatsapp'
            showAgreement={false}
            showNoWhatsappButton={false}
            agreementValue={phoneFormState.agreement}
            onSubmit={submitWhatsappForm}
          /> : 
          <PhoneForm
            active={true} 
            onSubmit={submitForm} 
            button='Узнать цену'
            phoneFormState={phoneFormState}
          />
        }
      </>}
		</section>
	);
}
